// src/main.tsx
// All comments in English.
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { WithQueryClient } from "./core/query";
import { AuthProvider } from "./auth/hooks/useAuth";
import "./styles/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <WithQueryClient>
      <AuthProvider>           {/* ← wrap App here */}
        <App />
      </AuthProvider>
    </WithQueryClient>
  </BrowserRouter>
);
